import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AuthService } from '@klickdata/core/auth';
import { Resource, AppScope } from '@klickdata/core/resource';
import { CourseItemBuilderDirective } from '@klickdata/core/resource/src/course-item-builder-directive';
import { ResourceBuildingItems, ResourceTypes } from '@klickdata/core/resource/src/types.enum';
import { CourseManagerCreateScormComponent } from '@klickdata/shared-components/src/course-manager-core/course-manager-core-items/course-manager-core-add-scorm/course-manager-create-scorm/course-manager-create-scorm.component';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
    selector: 'app-course-manager-core-add-scorm',
    templateUrl: './course-manager-core-add-scorm.component.html',
    styleUrls: ['./course-manager-core-add-scorm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CourseManagerCoreAddScormComponent extends CourseItemBuilderDirective implements OnInit {
    @Input() selection: number[] = [];
    @Input() display: ResourceBuildingItems;
    @Output() onError: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() add: EventEmitter<{ res: Resource; isParentSubmission?: boolean }> = new EventEmitter<{
        res: Resource;
        isParentSubmission?: boolean;
    }>();
    @Output() onMultiSelect: EventEmitter<{ res: Resource[]; isParentSubmission?: boolean }> = new EventEmitter<{
        res: Resource[];
        isParentSubmission?: boolean;
    }>();
    @Output() selectChange: EventEmitter<{ value: Resource; selected: boolean }> = new EventEmitter();
    @Output() onCloseView: EventEmitter<boolean> = new EventEmitter<boolean>();
    AppScope = AppScope;
    ResourceBuildingItems = ResourceBuildingItems;
    ResourceTypes = ResourceTypes;
    public showCreationOption: boolean;
    @ViewChild('compRef') compRef: CourseManagerCreateScormComponent;

    public isAdmin$: Observable<boolean>;
    constructor(protected auth: AuthService) {
        super();
    }
    ngOnInit() {
        this.isAdmin$ = this.auth.getUser().pipe(
            first(),
            map((user) => user.isAdmin())
        );
    }
    submit() {
        if (this.display === ResourceBuildingItems.CREATE_NEW_SCORM) {
            this.compRef?.onSubmit();
        }
    }
}
